const productList = [
	{
		id: 0,
		name: 'Dell Latitude 5420',
		price: '41900',
		originalPrice: '84900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp14-spaceblack-gallery1-202410.jpeg',
		],
		details:
			'i7 11th gen, 16GB Ram, Hard disk - 256GB NVMe\
14 Display\
OS - Windows 10 Pro',
		features: 'Microsoft Compliant',
		additionFeatures: '',
		type: 'refurbished',
	},
	{
		id: 1,
		name: 'Lenovo Thinkpad T480',
		price: '38900',
		originalPrice: '74900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp14-spaceblack-gallery1-202410.jpeg',
		],
		details:
			'i7 8th gen, 16GB RAM, Hard disk - 256GB NVMe\
14 Display\
OS - Windows 10 Pro',
		features: 'Microsoft Compliant',
		additionFeatures: '',
		type: 'refurbished',
	},
	{
		id: 2,
		name: 'Dell Latitude 5310',
		price: '21240',
		originalPrice: '45900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp14-spaceblack-gallery1-202410.jpeg',
		],
		details:
			'i5 8th gen, 16GB RAM, Hard disk - 256GB NVMe\
14 Display\
OS - Windows 10 Pro',
		features: 'Microsoft Compliant',
		additionFeatures: '',
		type: 'refurbished',
	},
	{
		id: 3,
		name: 'Dell Latitude 3410',
		price: '30680',
		originalPrice: '54900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp14-spaceblack-gallery1-202410.jpeg',
		],
		details:
			'i5 10th gen, 16GB RAM, Hard disk - 256GB NVMe\
14 Display\
OS - Windows 10 Pro',
		features: 'Microsoft Compliant',
		additionFeatures: '',
		type: 'refurbished',
	},
	{
		id: 4,
		name: 'Lenovo Thinkpad L14',
		price: '30680',
		originalPrice: '54900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp14-spaceblack-gallery1-202410.jpeg',
		],
		details:
			'i5 10th/11th gen, 16GB RAM, 256GB NVMe\
14 Display\
OS - Windows 10 Pro',
		features: 'Microsoft Compliant',
		additionFeatures: '',
		type: 'refurbished',
	},
	{
		id: 5,
		name: 'Macbook Pro A2141 16',
		price: '55900',
		originalPrice: '84900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp14-spaceblack-gallery1-202410.jpeg',
		],
		details:
			'i7, 16GB, 512GB SSD\
4GB AMD Radeon graphic card\
1.5GB Intel Iris Graphic card\
16 Display\
OS - Mac OS',
		features:
			'Retina Display\
Touch ID\
Touchbar',
		additionFeatures: '',
		type: 'refurbished',
	},
	{
		id: 6,
		name: 'Macbook Pro A2251 13',
		price: '49900',
		originalPrice: '74900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp14-spaceblack-gallery1-202410.jpeg',
		],
		details:
			'i7, 16GB, 512GB SSD\
1.5GB Intel Iris Graphic card\
13 Display\
OS - Mac OS',
		features:
			'Retina Display\
Touch ID\
Touchbar',
		additionFeatures: '',
		type: 'refurbished',
	},
	{
		id: 7,
		name: 'Macbook Pro 14',
		price: '159706',
		originalPrice: '169900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-5.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-6.jpeg',
		],
		details: 'Apple M4 chip 10 core CPU, 10 core GPU',
		features:
			'Retina Display\
Touch ID',
		additionFeatures:
			'Three Thunderbolt 4 ports, HDMI port, SDXC card slot, headphone jack, MagSafe 3 port\
Magic Keyboard with Touch ID\
Force Touch trackpad\
70W USB-C Power Adapter',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '16GB',
				HDD: '512GB',
				price: 159706,
				originalPrice: 169900,
			},

			{
				variant: 2,
				RAM: '24GB',
				HDD: '512GB',
				price: 179706,
				originalPrice: 189900,
			},

			{
				variant: 3,
				RAM: '16GB',
				HDD: '1024GB',
				price: 179706,
				originalPrice: 189900,
			},

			{
				variant: 4,
				RAM: '24GB',
				HDD: '1024GB',
				price: 189706,
				originalPrice: 209900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '16GB',
						label: '16GB Unified memory',
						priceDifference: 0,
					},
					{
						value: '24GB',
						label: '24GB Unified memory',
						priceDifference: 20000,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 0,
					},
					{
						value: '1024GB',
						label: '1TB SSD',
						priceDifference: 20000,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 8,
		name: 'Macbook Pro 14',
		price: '187906',
		originalPrice: '199900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-5.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-6.jpeg',
		],
		details: 'Apple M4 Pro chip 12 core CPU, 16 core GPU',
		features:
			'Retina Display\
Touch ID',
		additionFeatures:
			'Three Thunderbolt 4 ports, HDMI port, SDXC card slot, headphone jack, MagSafe 3 port\
Magic Keyboard with Touch ID\
Force Touch trackpad\
70W USB-C Power Adapter',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '24GB',
				HDD: '512GB',
				originalPrice: 199900,
				price: 187906,
			},
			{
				variant: 2,
				RAM: '36GB',
				HDD: '512GB',
				originalPrice: 219900,
				price: 207906,
			},
			{
				variant: 3,
				RAM: '48GB',
				HDD: '512GB',
				originalPrice: 239900,
				price: 227906,
			},
			{
				variant: 4,
				RAM: '64GB',
				HDD: '512GB',
				originalPrice: 259900,
				price: 247906,
			},
			{
				variant: 5,
				RAM: '24GB',
				HDD: '1024GB',
				originalPrice: 219900,
				price: 207906,
			},
			{
				variant: 6,
				RAM: '36GB',
				HDD: '1024GB',
				originalPrice: 239900,
				price: 227906,
			},
			{
				variant: 7,
				RAM: '48GB',
				HDD: '1024GB',
				originalPrice: 259900,
				price: 247906,
			},
			{
				variant: 8,
				RAM: '64GB',
				HDD: '1024GB',
				originalPrice: 279900,
				price: 267906,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '24GB',
						label: '24GB Unified memory',
						priceDifference: 0,
					},
					{
						value: '36GB',
						label: '36GB Unified memory',
						priceDifference: 20000,
					},
					{
						value: '48GB',
						label: '48GB Unified memory',
						priceDifference: 40000,
					},
					{
						value: '64GB',
						label: '64GB Unified memory',
						priceDifference: 60000,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '1024GB',
						label: '1TB SSD',
						priceDifference: 20000,
					},
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 9,
		name: 'Macbook Pro 14',
		price: '206706',
		originalPrice: '219900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-5.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-6.jpeg',
		],
		details: 'Apple M4 Pro chip 14 core CPU, 20 core GPU',
		features:
			'Retina Display\
Touch ID',
		additionFeatures:
			'Three Thunderbolt 4 ports, HDMI port, SDXC card slot, headphone jack, MagSafe 3 port\
Magic Keyboard with Touch ID\
Force Touch trackpad\
70W USB-C Power Adapter',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '24GB',
				HDD: '512GB',
				price: 206706,
				originalPrice: 219900,
			},
			{
				variant: 2,
				RAM: '48GB',
				HDD: '512GB',
				price: 246706,
				originalPrice: 219900,
			},
			{
				variant: 3,
				RAM: '64GB',
				HDD: '512GB',
				price: 266706,
				originalPrice: 219900,
			},
			{
				variant: 4,
				RAM: '24GB',
				HDD: '1024GB',
				price: 226706,
				originalPrice: 219900,
			},
			{
				variant: 5,
				RAM: '48GB',
				HDD: '1024GB',
				price: 266706,
				originalPrice: 219900,
			},
			{
				variant: 6,
				RAM: '64GB',
				HDD: '1024GB',
				price: 286706,
				originalPrice: 219900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '24GB',
						label: '24GB Unified memory',
						priceDifference: 0,
					},
					{
						value: '48GB',
						label: '48GB Unified memory',
						priceDifference: 40000,
					},
					{
						value: '64GB',
						label: '64GB Unified memory',
						priceDifference: 60000,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '1024GB',
						label: '1TB SSD',
						priceDifference: 20000,
					},
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 10,
		name: 'Macbook Pro 14',
		price: '300706',
		originalPrice: '319900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-5.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-6.jpeg',
		],
		details: 'Apple M4 Max chip 14 core CPU, 32 core GPU',
		features:
			'Retina Display\
Touch ID',
		additionFeatures:
			'Three Thunderbolt 4 ports, HDMI port, SDXC card slot, headphone jack, MagSafe 3 port\
Magic Keyboard with Touch ID\
Force Touch trackpad\
70W USB-C Power Adapter',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '36GB',
				HDD: '512GB',
				price: 300706,
				originalPrice: 319900,
			},
			{
				variant: 2,
				RAM: '64GB',
				HDD: '512GB',
				price: 340706,
				originalPrice: 359900,
			},
			{
				variant: 4,
				RAM: '36GB',
				HDD: '1024GB',
				price: 320706,
				originalPrice: 339900,
			},
			{
				variant: 5,
				RAM: '64GB',
				HDD: '1024GB',
				price: 360706,
				originalPrice: 379900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '36GB',
						label: '36GB Unified memory',
						priceDifference: 0,
					},
					{
						value: '64GB',
						label: '64GB Unified memory',
						priceDifference: 40000,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 0,
					},
					{
						value: '1024GB',
						label: '1TB SSD',
						priceDifference: 20000,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 11,
		name: 'Macbook Pro 14',
		price: '347706',
		originalPrice: '369900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-5.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-6.jpeg',
		],
		details: 'Apple M4 Max chip 14 core CPU, 40 core GPU',
		features:
			'Retina Display\
Touch ID',
		additionFeatures:
			'Three Thunderbolt 4 ports, HDMI port, SDXC card slot, headphone jack, MagSafe 3 port\
Magic Keyboard with Touch ID\
Force Touch trackpad\
70W USB-C Power Adapter',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '64GB',
				HDD: '512GB',
				price: 347706,
				originalPrice: 369900,
			},

			{
				variant: 2,
				RAM: '64GB',
				HDD: '1024GB',
				price: 367706,
				originalPrice: 389900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '64GB',
						label: '64GB Unified memory',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 0,
					},
					{
						value: '1024GB',
						label: '1TB SSD',
						priceDifference: 20000,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 12,
		name: 'Macbook Pro 16',
		price: '253706',
		originalPrice: '269900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-5.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-6.jpeg',
		],
		details: 'Apple M4 Pro chip with 14‑core CPU, 20‑core GPU and 16‑core Neural Engine',
		features:
			'Retina Display\
Touch ID',
		additionFeatures:
			'Three Thunderbolt 4 ports, HDMI port, SDXC card slot, headphone jack, MagSafe 3 port\
Magic Keyboard with Touch ID\
Force Touch trackpad\
70W USB-C Power Adapter',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '24GB',
				HDD: '512GB',
				price: 253706,
				originalPrice: 269900,
			},
			{
				variant: 2,
				RAM: '24GB',
				HDD: '1024GB',
				price: 273706,
				originalPrice: 289900,
			},
			{
				variant: 3,
				RAM: '48GB',
				HDD: '512GB',
				price: 293706,
				originalPrice: 309900,
			},
			{
				variant: 4,
				RAM: '48GB',
				HDD: '1024GB',
				price: 313706,
				originalPrice: 329900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '24GB',
						label: '24GB Unified memory',
						priceDifference: 0,
					},
					{
						value: '48GB',
						label: '48GB Unified memory',
						priceDifference: 40000,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 0,
					},
					{
						value: '1024GB',
						label: '1TB SSD',
						priceDifference: 20000,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 13,
		name: 'Macbook Pro 16',
		price: '328906',
		originalPrice: '349900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-5.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-6.jpeg',
		],
		details: 'Apple M4 Max chip with 14‑core CPU, 32‑core GPU and 16‑core Neural Engine',
		features:
			'Retina Display\
Touch ID',
		additionFeatures:
			'Three Thunderbolt 4 ports, HDMI port, SDXC card slot, headphone jack, MagSafe 3 port\
Magic Keyboard with Touch ID\
Force Touch trackpad\
70W USB-C Power Adapter',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '36GB',
				HDD: '1024GB',
				price: 328906,
				originalPrice: 349900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '36GB',
						label: '36GB Unified memory',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '1024GB',
						label: '1TB SSD',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 14,
		name: 'Macbook Pro 16',
		price: '375906',
		originalPrice: '399900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-5.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mbp16-spaceblack-gallery7-202410-6.jpeg',
		],
		details: 'Apple M4 Max chip with 16‑core CPU, 40‑core GPU and 16‑core Neural Engine',
		features:
			'Retina Display\
Touch ID',
		additionFeatures:
			'Three Thunderbolt 4 ports, HDMI port, SDXC card slot, headphone jack, MagSafe 3 port\
Magic Keyboard with Touch ID\
Force Touch trackpad\
70W USB-C Power Adapter',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '48GB',
				HDD: '1024GB',
				price: 375906,
				originalPrice: 399900,
			},
			{
				variant: 2,
				RAM: '64GB',
				HDD: '1024GB',
				price: 395906,
				originalPrice: 419900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '48GB',
						label: '48GB Unified memory',
						priceDifference: 0,
					},
					{
						value: '64GB',
						label: '64GB Unified memory',
						priceDifference: 20000,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '1024GB',
						label: '1TB SSD',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 15,
		name: 'Macbook Air 13',
		price: '93906',
		originalPrice: '99900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-5.jpeg',
		],
		details: 'Apple M4 chip 10 core CPU, 8 core GPU',
		features:
			'Retina Display\
Touch ID',
		additionFeatures: '',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '16GB',
				HDD: '256GB',
				price: 93906,
				originalPrice: 99900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '16GB',
						label: '16GB Unified memory',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '256GB',
						label: '256GB SSD',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 16,
		name: 'Macbook Air 13',
		price: '103306',
		originalPrice: '109900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-5.jpeg',
		],
		details: 'Apple M4 chip 10 core CPU, 10 core GPU',
		features:
			'Retina Display\
Touch ID',
		additionFeatures: '',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '16GB',
				HDD: '256GB',
				price: 103306,
				originalPrice: 109900,
			},
			{
				variant: 2,
				RAM: '16GB',
				HDD: '512GB',
				price: 123306,
				originalPrice: 129900,
			},
			{
				variant: 3,
				RAM: '24GB',
				HDD: '256GB',
				price: 123306,
				originalPrice: 129900,
			},
			{
				variant: 4,
				RAM: '24GB',
				HDD: '512GB',
				price: 143306,
				originalPrice: 149900,
			},
			{
				variant: 5,
				RAM: '32GB',
				HDD: '256GB',
				price: 143306,
				originalPrice: 149900,
			},
			{
				variant: 6,
				RAM: '32GB',
				HDD: '512GB',
				price: 163306,
				originalPrice: 169900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '16GB',
						label: '16GB Unified memory',
						priceDifference: 0,
					},
					{
						value: '24GB',
						label: '24GB Unified memory',
						priceDifference: 20000,
					},
					{
						value: '32GB',
						label: '32GB Unified memory',
						priceDifference: 40000,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '256GB',
						label: '256GB SSD',
						priceDifference: 0,
					},
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 20000,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 17,
		name: 'Macbook Air 15',
		price: '117406',
		originalPrice: '124900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba15/mba15-m4-starlight-gallery6-202503-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba15/mba15-m4-starlight-gallery6-202503-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba15/mba15-m4-starlight-gallery6-202503-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba15/mba15-m4-starlight-gallery6-202503-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba15/mba15-m4-starlight-gallery6-202503-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba15/mba15-m4-starlight-gallery6-202503-5.jpeg',
		],
		details: 'Apple M4 chip 10 core CPU, 10 core GPU',
		features:
			'Retina Display\
Touch ID',
		additionFeatures: '',
		type: 'new',
		row: 20,
		allVariants: [
			{
				variant: 1,
				RAM: '16GB',
				HDD: '256GB',
				price: 117406,
				originalPrice: 124900,
			},
			{
				variant: 2,
				RAM: '16GB',
				HDD: '512GB',
				price: 137406,
				originalPrice: 144900,
			},
			{
				variant: 3,
				RAM: '24GB',
				HDD: '256GB',
				price: 137406,
				originalPrice: 144900,
			},
			{
				variant: 4,
				RAM: '24GB',
				HDD: '512GB',
				price: 147406,
				originalPrice: 154900,
			},
			{
				variant: 5,
				RAM: '32GB',
				HDD: '256GB',
				price: 147406,
				originalPrice: 154900,
			},
			{
				variant: 6,
				RAM: '32GB',
				HDD: '512GB',
				price: 167406,
				originalPrice: 164900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '16GB',
						label: '16GB Unified memory',
						priceDifference: 0,
					},
					{
						value: '24GB',
						label: '24GB Unified memory',
						priceDifference: 20000,
					},
					{
						value: '32GB',
						label: '32GB Unified memory',
						priceDifference: 40000,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '256GB',
						label: '256GB SSD',
						priceDifference: 0,
					},
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 20000,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 18,
		name: 'Macbook Air 13',
		price: '62390.6',
		originalPrice: '89900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-5.jpeg',
		],
		details: 'Apple M1 chip 8 core CPU, 7 core GPU',
		features:
			'Retina Display\
Touch ID',
		additionFeatures: '',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '8GB',
				HDD: '256GB',
				price: 62390,
				originalPrice: 89900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '8GB',
						label: '8GB Unified memory',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '256GB',
						label: '256GB SSD',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 19,
		name: 'Macbook Air 13',
		price: '76923',
		originalPrice: '99900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-5.jpeg',
		],
		details: 'Apple M2 chip 8 core CPU, 10 core GPU',
		features:
			'Retina Display\
Touch ID',
		additionFeatures: '',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '8GB',
				HDD: '256GB',
				price: 76923,
				originalPrice: 99900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '8GB',
						label: '8GB Unified memory',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '256GB',
						label: '256GB SSD',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 20,
		name: 'Macbook Air 13',
		price: '98477',
		originalPrice: '134900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-0.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-4.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mba13/mba13-m4-skyblue-gallery6-202503-5.jpeg',
		],
		details: 'Apple M3 chip 8 core CPU,  core GPU',
		features:
			'Retina Display\
Touch ID',
		additionFeatures: '',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '8GB',
				HDD: '256GB',
				price: 98477,
				originalPrice: 134900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '8GB',
						label: '8GB Unified memory',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '256GB',
						label: '256GB SSD',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 21,
		name: 'Dell Latitude 3440 14',
		price: '55250',
		originalPrice: '85000',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/dell-3440/9-0.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/dell-3440/9-1.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/dell-3440/9-2.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/dell-3440/9-3.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/dell-3440/9-4.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/dell-3440/9-5.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/dell-3440/9-6.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/dell-3440/9-7.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/dell-3440/9-8.jpg',
		],
		details:
			'i5 12th gen, 16GB, 512SSD\
3 years ADP + 3 years Warranty\
Windows 10 Pro',
		features: '',
		additionFeatures: '',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '16GB',
				HDD: '512GB',
				price: 55250,
				originalPrice: 85000,
			},
			{
				variant: 2,
				RAM: '16GB',
				HDD: '1024GB',
				price: 61250,
				originalPrice: 91000,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '16GB',
						label: '16GB Unified memory',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 0,
					},
					{
						value: '1024GB',
						label: '1024GB SSD',
						priceDifference: 6000,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 22,
		name: 'Lenovo Thinkpad E14 G5 14',
		price: '85644',
		originalPrice: '140400',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenno-thinkpad-e14/8-0.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenno-thinkpad-e14/8-1.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenno-thinkpad-e14/8-2.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenno-thinkpad-e14/8-3.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenno-thinkpad-e14/8-4.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenno-thinkpad-e14/8-5.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenno-thinkpad-e14/8-6.jpg',
		],
		details:
			'Intel® Core™ i7-1255U/\
RAM 16GB\
512GB\
Windows 10 Pro\
3Y Onsite & 3Y',
		features: '',
		additionFeatures: '',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '16GB',
				HDD: '512GB',
				price: 85644,
				originalPrice: 140400,
			},
			{
				variant: 2,
				RAM: '16GB',
				HDD: '1024GB',
				price: 91644,
				originalPrice: 146400,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '16GB',
						label: '16GB Unified memory',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 0,
					},
					{
						value: '1024GB',
						label: '1024GB SSD',
						priceDifference: 6000,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 23,
		name: 'Lenovo LOQ 15.6\
Gaming\
83DV00MKIN',
		price: '100288.8',
		originalPrice: '139290',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenovo-loq/6.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenovo-loq/6-0.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenovo-loq/6-1.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenovo-loq/6-2.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenovo-loq/6-3.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenovo-loq/6-4.jpg',
		],
		details:
			'i7 13650HX   \
Windows 11 \
Office 2021 \
RTX 4050 6GB \
1 Year Onsite \
1 Year ADP \
4 Zone RGB',
		features: '',
		additionFeatures: '',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '24GB',
				HDD: '1024GB',
				price: 100288,
				originalPrice: 139290,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '24GB',
						label: '24GB Unified memory',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '1024GB',
						label: '1024GB SSD',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 24,
		name: 'Lenovo LOQ 15.6\
Gaming\
83DV00MKIN',
		price: '129675',
		originalPrice: '172900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenovo-loq/6-0.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenovo-loq/6.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenovo-loq/6-1.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenovo-loq/6-2.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenovo-loq/6-3.jpg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/lenovo-loq/6-4.jpg',
		],
		details:
			'i7 14700HX  \
\
Windows 11 \
Office 2021 \
RTX 4050 6GB \
1 Year Onsite \
1 Year ADP \
4 Zone RGB',
		features: '',
		additionFeatures: '',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '16GB',
				HDD: '512GB',
				price: 129675,
				originalPrice: 172900,
			},
			{
				variant: 1,
				RAM: '16GB',
				HDD: '1024GB',
				price: 135675,
				originalPrice: 178900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '16GB',
						label: '16GB Unified memory',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 0,
					},
					{
						value: '1024GB',
						label: '1024GB SSD',
						priceDifference: 6000,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 25,
		name: 'MAC MINI',
		price: '140906',
		originalPrice: '149900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mac_mini/mac1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mac_mini/mac2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mac_mini/mac3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mac_mini/mac4-reduce.jpeg',
		],
		details: 'Apple M4 Pro chip with 12‑core CPU, 16‑core GPU, 16‑core Neural Engine',
		features:
			'Retina Display\
Touch ID',
		additionFeatures:
			'Three Thunderbolt 5 ports,\
		 HDMI port,\
		  two USB‑C ports,\
		   headphone jack',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '24GB',
				HDD: '512GB',
				price: 140906,
				originalPrice: 149900,
			},
			{
				variant: 2,
				RAM: '64GB',
				HDD: '512GB',
				price: 197306,
				originalPrice: 209900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '24GB',
						label: '24GB Unified memory',
						priceDifference: 0,
					},
					{
						value: '64GB',
						label: '64GB Unified memory',
						priceDifference: 60000,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 26,
		name: 'MAC MINI',
		price: '56306',
		originalPrice: '59900',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mac_mini/mac1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mac_mini/mac2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mac_mini/mac3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/mac_mini/mac4-reduce.jpeg',
		],
		details: 'Apple M4 Pro chip with 10‑core CPU, 10‑core GPU',
		features:
			'Retina Display\
Touch ID',
		additionFeatures:
			'Three Thunderbolt 5 ports,\
		 HDMI port,\
		  two USB‑C ports,\
		   headphone jack',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '16GB',
				HDD: '256GB',
				price: 56306,
				originalPrice: 59900,
			},
			{
				variant: 2,
				RAM: '16GB',
				HDD: '512GB',
				price: 76306,
				originalPrice: 79900,
			},
			{
				variant: 3,
				RAM: '32GB',
				HDD: '256GB',
				price: 76306,
				originalPrice: 79900,
			},
			{
				variant: 4,
				RAM: '32GB',
				HDD: '512GB',
				price: 96306,
				originalPrice: 99900,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '16GB',
						label: '16GB Unified memory',
						priceDifference: 0,
					},
					{
						value: '32GB',
						label: '32GB Unified memory',
						priceDifference: 20000,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '256GB',
						label: '256GB SSD',
						priceDifference: 0,
					},
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 20000,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 27,
		name: 'Samsung Galaxy Book5 Pro',
		price: '126500',
		originalPrice: '187190',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/Samsung_Galaxy_Book5_Pro/sam1.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/Samsung_Galaxy_Book5_Pro/sam2.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/Samsung_Galaxy_Book5_Pro/sam3.jpeg',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/Samsung_Galaxy_Book5_Pro/sam4.jpeg',
		],
		details:
			'Samsung Galaxy Book5 Pro| Intel Evo Core Ultra 7 256V| Built-in AI | 14" (35.56cm) Touchscreen Dynamic AMOLED 2X 120Hz | 500 Nits',
		features: '',
		additionFeatures: '',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '16GB',
				HDD: '512GB',
				price: 126500,
				originalPrice: 187190,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '16GB',
						label: '16GB memory',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '512GB',
						label: '512GB SSD',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
		],
	},
	{
		id: 28,
		name: 'ASUS Zenbook S 14',
		price: '149990',
		originalPrice: '182990',
		rating: 5,
		badge: '-6%',
		images: [
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/asus1/Screenshot+2025-04-26+at+7.21.23%E2%80%AFAM-optimized.webp',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/asus1/Screenshot+2025-04-26+at+7.18.36%E2%80%AFAM-optimized.webp',
			'https://azpublicall.s3.ap-south-1.amazonaws.com/products-images/asus1/Screenshot+2025-04-26+at+7.21.32%E2%80%AFAM-optimized.webp',
		],
		details: 'Intel Core Ultra 7 (Series 2), 32GB RAM, 1TB SSD, 3K OLED Touch 120Hz',
		features: '',
		additionFeatures: '',
		type: 'new',
		allVariants: [
			{
				variant: 1,
				RAM: '32GB',
				HDD: '1024GB',
				price: 149990,
				originalPrice: 182990,
			},
		],
		resourcePoints: [
			{
				label: 'Memory',
				key: 'RAM',
				options: [
					{
						value: '32GB',
						label: '32GB memory',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
			{
				label: 'Hard Disk',
				key: 'HDD',
				options: [
					{
						value: '1024GB',
						label: '1024GB SSD',
						priceDifference: 0,
					},
				],
				selectedPoint: 0,
			},
		],
	},
];

function getAllProducts() {
	return productList.filter((el) => el.type === 'new');
}

function getDevice(id) {
	return productList.find((el) => el.id === id * 1);
}

module.exports = { getAllProducts: getAllProducts, getDevice };
